<div
  class="fdx-c-notification fdx-c-notification--success  fdx-c-notification--block fdx-c-notification--toast fdx-c-notification--position-bottom-right">
  <div class="fdx-c-notification__main">
    <div class="fdx-c-notification__header">
      <ciam-icon class="fdx-c-icon" aria-hidden="true" key="check-mark-circle"></ciam-icon>
    </div>
    <div class="fdx-c-notification__body">
      <div class="fdx-c-notification__description">
        @if (!messageFlag) {
          <p class="fdx-u-font-size--small fdx-u-m--0 fdx-u-pl--2"
            attr.aria-label="{{ 'successNotification.description' | translate}}" id="success-message">
            {{ 'successNotification.description' | translate}}
          </p>
        }
        @if (messageFlag === 'loginSuccess') {
          <p  class="fdx-u-font-size--small fdx-u-m--0 fdx-u-pl--2"
            attr.aria-label="{{ 'successNotification.description' | translate}}" id="success-message">
            {{ 'successNotification.loginSuccessDescription' | translate}}
          </p>
        }
        @if (messageFlag === 'contactSaveSuccessful') {
          <p class="fdx-u-font-size--small fdx-u-m--0 fdx-u-pl--2"
            attr.aria-label="{{ 'successNotification.contactUpdateDescription' | translate}}" id="success-message">
            {{ 'successNotification.contactUpdateDescription' | translate}}
          </p>
        }
      </div>
    </div>


    <div class="fdx-c-notification__footer">
      <button class="fdx-c-button fdx-c-button--icon" id="cross-button" (click)="closeToast()"
        attr.aria-label="{{'successNotification.closeButton' | translate}}">
        <ciam-icon class="fdx-c-icon" aria-hidden="true" key="cross"></ciam-icon>
      </button>
    </div>
  </div>
</div>
